import {
  PayoutHistoryListComponent
} from "@features/accounts/payout-history/payout-history-list/payout-history-list.component";
import {
  RunClientPayoutsViewComponent
} from "@features/accounts/run-client-payouts/run-client-payouts-view/run-client-payouts-view.component";
import {RunProductsComponent} from "@features/accounts/run-products/run-products.component";
import {
  RunTenantPayoutsViewComponent
} from "@features/accounts/run-tenant-payouts/run-tenant-payouts-view/run-tenant-payouts-view.component";
import {TradingReportComponent} from "@features/accounts/trading-report/trading-report.component";
import {
  DailyTransactionSummaryComponent
} from "@features/accounts/transactions/transactions-list-view/daily-transaction-summary/daily-transaction-summary.component";
import {
  TransactionsScheduleComponent
} from "@features/accounts/transactions/transactions-list-view/transactions-schedule/transactions-schedule.component";
import {AtokuAccessEntriesComponent} from "@features/atoku/atoku-access-entries/atoku-access-entries.component";
import {AtokuAccessRequestsComponent} from "@features/atoku/atoku-access-requests/atoku-access-requests.component";
import {AtokuBookingConfigComponent} from "@features/atoku/atoku-booking-config/atoku-booking-config.component";
import {AtokuCalendarComponent} from "@features/atoku/atoku-calendar/atoku-calendar.component";
import {AtokuCategoriesComponent} from "@features/atoku/atoku-categories/atoku-categories.component";
import {AtokuEquipmentComponent} from "@features/atoku/atoku-equipment/atoku-equipment.component";
import {AtokuPricingProfilesComponent} from "@features/atoku/atoku-pricing-profiles/atoku-pricing-profiles.component";
import {AtokuReportsComponent} from "@features/atoku/atoku-reports/atoku-reports.component";
import {AtokuStationsComponent} from "@features/atoku/atoku-stations/atoku-stations.component";
import {AtokuStorageComponent} from "@features/atoku/atoku-storage/atoku-storage.component";
import {AtokuUsersComponent} from "@features/atoku/atoku-users/atoku-users.component";
import {
  DashboardFootfallComponentComponent
} from "@features/dashboards/dashboard-footfall-component/dashboard-footfall-component.component";
import {
  DashboardsLeadsReportComponent
} from "@features/dashboards/dashboards-leads-report/dashboards-leads-report.component";
import {
  DashboardsLeasingReportComponent
} from "@features/dashboards/dashboards-leasing-report/dashboards-leasing-report.component";
import {
  DashboardsPerformanceReportComponent
} from "@features/dashboards/dashboards-performance-report/dashboards-performance-report.component";
import {
  DashboardsRetailerReportComponent
} from "@features/dashboards/dashboards-retailer-report/dashboards-retailer-report.component";
import {
  ManageApplicationFormsComponent
} from '@features/leads/application-form-builder/manage-application-forms/manage-application-forms.component';
import {ApplicationsListComponent} from "@features/leads/applications/applications-list/applications-list.component";
import {PipelineListComponent} from "@features/leads/pipeline/pipeline-list/pipeline-list.component";
import {RetailersListComponent} from "@features/leads/retailers/retailers-list/retailers-list.component";
import {ManageSurveysComponent} from "@features/leads/surveys/manage-surveys/manage-surveys.component";
import {
  LeasePlanningViewComponent
} from "@features/leasing/lease-planning/lease-planning-view/lease-planning-view.component";
import {
  DefaultTableViewMode,
  LeaseScheduleListComponent
} from "@features/leasing/lease-schedule/lease-schedule-list/lease-schedule-list.component";
import {LeaseViewComponent} from "@features/leasing/lease-view/lease-view.component";
import {LeaseFilterType, LeaseStatus} from "@features/leasing/leasing.model";
import {LeaseBookingsComponent} from "@features/leasing/lease-bookings/lease-bookings.component";
import {SettingsDetailsComponent} from '@features/settings/details/settings-details.component';
import {HardwareSettingsComponent} from '@features/settings/hardware-settings/hardware-settings.component';
import {ManageIndustriesComponent} from "@features/settings/industries/manage-industries/manage-industries.component";
import {PaymentsSettingsComponent} from "@features/settings/payments/payments-settings.component";
import {
  SettingsBillingAndBankingComponent
} from '@features/settings/settings-billing-and-banking/settings-billing-and-banking.component';
import {TemplateBuilderComponent} from '@features/settings/template-builder/template-builder.component';
import {UsersAndAccessComponent} from '@features/settings/users-and-access/users-and-access.component';
import {ManageSpacesComponent} from '@features/spaces/manage-spaces/manage-spaces.component';
import {CustomerSupportComponent} from "@features/support/customer-support/customer-support.component";
import {PageSectionInfo, PageSectionItemInfo} from "../model/side-nav.model";

export const dashboardSection: PageSectionInfo = {
  code: 'dashboards',
  label: 'Dashboards',
  icon: 'bar_chart'
}

const DASHBOARD_PAGE_SECTION: PageSectionInfo = {
  code: 'dashboards',
  label: 'Dashboards',
  icon: 'bar_chart'
}

export const internalAdminSection: PageSectionInfo = {
  code: 'internal_admin',
  label: 'Internal Admin',
  icon: 'bar_chart'
}

const PIPELINE_PAGE_SECTION: PageSectionInfo = {
  code: 'leads',
  label: 'Leads',
  icon: 'person_search'
};
const LEASING_PAGE_SECTION: PageSectionInfo = {
  code: 'leasing',
  label: 'Leasing',
  icon: 'assignment_ind'
};
const SPACES_PAGE_SECTION: PageSectionInfo = {
  code: 'spaces',
  label: 'Spaces',
  icon: 'space_dashboard'
};
const ACCOUNTS_PAGE_SECTION: PageSectionInfo = {
  code: 'accounts',
  label: 'Accounts',
  icon: 'account_balance_wallet'
};
const ON_DEMAND_PAGE_SECTION: PageSectionInfo = {
  code: 'on_demand',
  label: 'On-Demand Rentals',
  icon: 'assignment_ind'
}
const SETTINGS_PAGE_SECTION: PageSectionInfo = {
  code: 'settings',
  label: 'Settings',
  icon: 'settings_applications'
}

export const districtPageSections: PageSectionInfo[] = [
  DASHBOARD_PAGE_SECTION,
  PIPELINE_PAGE_SECTION,
  LEASING_PAGE_SECTION,
  SPACES_PAGE_SECTION,
  ACCOUNTS_PAGE_SECTION,
  SETTINGS_PAGE_SECTION
];

export const generalLeasingPageSections: PageSectionInfo[] = [
  DASHBOARD_PAGE_SECTION,
  PIPELINE_PAGE_SECTION,
  LEASING_PAGE_SECTION,
  SPACES_PAGE_SECTION,
  ACCOUNTS_PAGE_SECTION,
  SETTINGS_PAGE_SECTION
];

export const exhibitionPageSections: PageSectionInfo[] = [
  DASHBOARD_PAGE_SECTION,
  PIPELINE_PAGE_SECTION,
  LEASING_PAGE_SECTION,
  SPACES_PAGE_SECTION,
  ACCOUNTS_PAGE_SECTION,
  SETTINGS_PAGE_SECTION
];
export const kiosksPageSections: PageSectionInfo[] = [
  DASHBOARD_PAGE_SECTION,
  PIPELINE_PAGE_SECTION,
  LEASING_PAGE_SECTION,
  SPACES_PAGE_SECTION,
  ACCOUNTS_PAGE_SECTION,
  SETTINGS_PAGE_SECTION
];
export const marketsPageSections: PageSectionInfo[] = [
  DASHBOARD_PAGE_SECTION,
  PIPELINE_PAGE_SECTION,
  LEASING_PAGE_SECTION,
  SPACES_PAGE_SECTION,
  ACCOUNTS_PAGE_SECTION,
  SETTINGS_PAGE_SECTION
];
export const digitalAdvertisingPageSections: PageSectionInfo[] = [
  DASHBOARD_PAGE_SECTION,
  PIPELINE_PAGE_SECTION,
  LEASING_PAGE_SECTION,
  SPACES_PAGE_SECTION,
  ACCOUNTS_PAGE_SECTION,
  SETTINGS_PAGE_SECTION
];
export const popUpsPageSections: PageSectionInfo[] = [
  DASHBOARD_PAGE_SECTION,
  PIPELINE_PAGE_SECTION,
  LEASING_PAGE_SECTION,
  SPACES_PAGE_SECTION,
  ACCOUNTS_PAGE_SECTION,
  SETTINGS_PAGE_SECTION
];
export const storagePageSections: PageSectionInfo[] = [
  DASHBOARD_PAGE_SECTION,
  PIPELINE_PAGE_SECTION,
  LEASING_PAGE_SECTION,
  SPACES_PAGE_SECTION,
  ACCOUNTS_PAGE_SECTION,
  SETTINGS_PAGE_SECTION
];
export const onDemandPageSections: PageSectionInfo[] = [
  DASHBOARD_PAGE_SECTION,
  PIPELINE_PAGE_SECTION,
  SPACES_PAGE_SECTION,
  ON_DEMAND_PAGE_SECTION,
  SETTINGS_PAGE_SECTION
];

export const spacesItems: PageSectionItemInfo[] = [
  {
    label: 'All Spaces',
    componentToRegister: ManageSpacesComponent,
    pageName: 'Manage spaces',
    idPrefix: 'spaces_all',
    sectionCode: 'spaces',
    pageCode: 'spaces_all',
    openType: 'tab',
    data: {
      selectedTabCode: 'spaces'
    },
    featureCodes: ['spaces_admin']
  },
  {
    label: 'Stations',
    componentToRegister: AtokuStationsComponent,
    pageName: 'Stations',
    idPrefix: 'atoku_stations',
    sectionCode: 'spaces',
    pageCode: 'atoku_stations',
    openType: 'tab',
    data: {},
    featureCodes: ['atoku_stations_view']
  },
  {
    label: 'Equipment',
    componentToRegister: AtokuEquipmentComponent,
    pageName: 'Equipment',
    idPrefix: 'atoku_equipment',
    sectionCode: 'spaces',
    pageCode: 'atoku_equipment',
    openType: 'tab',
    data: {},
    featureCodes: ['atoku_equipment_view']
  },
  {
    label: 'Storage',
    componentToRegister: AtokuStorageComponent,
    pageName: 'Storage',
    idPrefix: 'atoku_storage',
    sectionCode: 'spaces',
    pageCode: 'atoku_storage',
    openType: 'tab',
    data: {},
    featureCodes: ['atoku_storage_view']
  },
]

export const pipelineItems: PageSectionItemInfo[] = [
  {
    label: 'Applications',
    componentToRegister: ApplicationsListComponent,
    pageName: 'Applications',
    idPrefix: 'applications',
    sectionCode: 'leads',
    pageCode: 'applications',
    openType: 'tab',
    data: {},
    featureCodes: ['pipeline_app_view_all']
  },
  {
    label: 'Pipeline',
    componentToRegister: PipelineListComponent,
    pageName: 'Pipeline',
    idPrefix: 'leads',
    sectionCode: 'leads',
    pageCode: 'leads',
    openType: 'tab',
    data: {},
    featureCodes: ['pipeline_pipeline_view_all', 'pipeline_pipeline_view_stats']
  },
  {
    label: 'Contacts',
    componentToRegister: RetailersListComponent,
    pageName: 'Contacts',
    idPrefix: 'retailers',
    sectionCode: 'leads',
    pageCode: 'retailers',
    openType: 'tab',
    data: {},
    featureCodes: ['pipeline_retailers_view_all']
  },
  {
    label: 'Application Form Builder',
    componentToRegister: ManageApplicationFormsComponent,
    pageName: 'Application Forms',
    idPrefix: 'application_forms',
    sectionCode: 'leads',
    pageCode: 'application_forms',
    openType: 'tab',
    data: {},
    featureCodes: ['settings_manage_forms_admin']
  },
  {
    label: 'Surveys',
    componentToRegister: ManageSurveysComponent,
    pageName: 'Surveys',
    idPrefix: 'surveys',
    sectionCode: 'leads',
    pageCode: 'survey_manage',
    openType: 'tab',
    data: {},
    featureCodes: ['settings_manage_forms_admin']
  }
]

export const settingsItems: PageSectionItemInfo[] = [
  {
    label: 'Details',
    componentToRegister: SettingsDetailsComponent,
    pageName: 'Settings',
    idPrefix: 'settings',
    sectionCode: 'settings',
    pageCode: 'settings',
    openType: 'tab',
    data: {},
    featureCodes: ['settings_details_view']
  },
  //Note: removed for now, not being used by clients
  // {
  //   label: 'Manage Listing',
  //   componentToRegister: ManageListingComponent,
  //   pageName: 'Manage Listing',
  //   idPrefix: 'manage_listing',
  //   sectionCode: 'settings',
  //   pageCode: 'manage_listing',
  //   openType: 'tab',
  //   data: {},
  //   featureCodes: ['settings_manage_listing_admin']
  // },
  {
    label: 'Users and access',
    componentToRegister: UsersAndAccessComponent,
    pageName: 'Users and access',
    idPrefix: 'users_and_settings',
    sectionCode: 'settings',
    pageCode: 'users_and_settings',
    openType: 'tab',
    data: {},
    featureCodes: ['settings_users_view_all']
  },
  {
    label: 'Hardware',
    componentToRegister: HardwareSettingsComponent,
    pageName: 'Hardware',
    idPrefix: 'hardware',
    sectionCode: 'settings',
    pageCode: 'hardware',
    openType: 'tab',
    data: {},
    featureCodes: ['settings_hardware_view_all']

  },
  {
    label: 'Billing and Banking Details',
    componentToRegister: SettingsBillingAndBankingComponent,
    pageName: 'District Banking details',
    idPrefix: 'district_banking_details',
    sectionCode: 'settings',
    pageCode: 'district_banking_details',
    openType: 'tab',
    data: {},
    featureCodes: ['settings_billing_and_banking_admin']
  },
  {
    label: 'Payments',
    componentToRegister: PaymentsSettingsComponent,
    pageName: 'Payments',
    idPrefix: 'payments',
    sectionCode: 'settings',
    pageCode: 'payments',
    openType: 'tab',
    data: {},
    featureCodes: ['settings_internal_admin']
  },
  {
    label: 'Notification Templates',
    componentToRegister: TemplateBuilderComponent,
    pageName: 'Notification Templates',
    pageCode: 'template_builder',
    idPrefix: 'template_builder',
    sectionCode: 'settings',
    openType: 'tab',
    data: {},
    featureCodes: ['settings_template_builder']
  },
  {
    label: 'Industries',
    componentToRegister: ManageIndustriesComponent,
    pageName: 'Manage Industries',
    pageCode: 'industries_manage',
    idPrefix: 'industries_manage',
    sectionCode: 'settings',
    openType: 'tab',
    data: {},
    featureCodes: ['settings_template_builder'] //todo - add a new feature code for this
  },
  {
    label: 'Booking Config',
    componentToRegister: AtokuBookingConfigComponent,
    pageName: 'Booking Config',
    idPrefix: 'atoku_booking_config',
    sectionCode: 'settings',
    pageCode: 'atoku_booking_config',
    openType: 'tab',
    data: {},
    featureCodes: ['atoku_booking_config_view']
  },
  {
    label: 'Pricing Profiles',
    componentToRegister: AtokuPricingProfilesComponent,
    pageName: 'Pricing Profiles',
    idPrefix: 'atoku_pricing_profiles',
    sectionCode: 'settings',
    pageCode: 'atoku_pricing_profiles',
    openType: 'tab',
    data: {},
    featureCodes: ['atoku_pricing_profiles_view']
  },
  {
    label: 'Categories',
    componentToRegister: AtokuCategoriesComponent,
    pageName: 'Categories',
    idPrefix: 'atoku_categories',
    sectionCode: 'settings',
    pageCode: 'atoku_categories',
    openType: 'tab',
    data: {},
    featureCodes: ['atoku_categories_view']
  },
]

export const leasingItems: PageSectionItemInfo[] = [
  {
    label: 'Occupancy and planning',
    componentToRegister: LeasePlanningViewComponent,
    pageName: 'Occupancy and planning',
    idPrefix: 'lease-planning',
    sectionCode: 'leasing',
    pageCode: 'lease-planning',
    openType: 'tab',
    data: {},
    featureCodes: ['leasing_planned_view_all', 'leasing_planned_view_occupancy']
  },
  {
    label: 'Planned leases',
    componentToRegister: LeaseScheduleListComponent,
    pageName: 'Planned Leases',
    idPrefix: 'planned-leases',
    sectionCode: 'leasing',
    pageCode: 'planned-leases',
    openType: 'tab',
    data: {
      table: {
        tableViewMode: DefaultTableViewMode.FULL,
        excludeDisplayColumns: ['tradingOutsideOfLeasePeriod']
      },
      lease: {
        leaseStatuses: [LeaseStatus.PLANNED, LeaseStatus.INVALID],
        filterTypes: [LeaseFilterType.LEASE_STATUS, LeaseFilterType.OCCUPANCY_TYPE, LeaseFilterType.DATE_RANGE, LeaseFilterType.COMPACT_VIEW],
        endpointSuffix: 'lease-schedule',
        pageCode: 'lease-schedule',
      },
      pageHeader: {
        title: 'Plan your next lease',
        description: 'Track and manage lease applications in progress — including planned dates, rates and any invalid entries needing review.'
      }
    },
    featureCodes: ['leasing_planned_view_all']
  },
  {
    label: 'Tenants',
    componentToRegister: LeaseScheduleListComponent,
    pageName: 'Tenants',
    idPrefix: 'current-leases',
    sectionCode: 'leasing',
    pageCode: 'current-leases',
    openType: 'tab',
    data: {
      table: {
        tableViewMode: DefaultTableViewMode.FULL,
      },
      lease: {
        leaseStatuses: [LeaseStatus.APPROVED, LeaseStatus.ACTIVE, LeaseStatus.EXPIRED],
        filterTypes: [LeaseFilterType.LEASE_STATUS, LeaseFilterType.OCCUPANCY_TYPE, LeaseFilterType.TERM_STATUS, LeaseFilterType.EXPIRES_IN, LeaseFilterType.DATE_RANGE, LeaseFilterType.COMPACT_VIEW],
        endpointSuffix: 'current-leases',
        pageCode: 'current-leases',
      },
      pageHeader: {
        title: 'Look who is currently leasing',
        description: 'This is all your current trading retailer leases summarising their lease terms. Stay on top of renewals by exploring their expiration periods.'
      }
    },
    featureCodes: ['leasing_current_view_all']
  },
  {
    label: 'Lease schedule',
    componentToRegister: LeaseScheduleListComponent,
    pageName: 'Lease schedule',
    idPrefix: 'lease-schedule',
    sectionCode: 'leasing',
    pageCode: 'lease-schedule',
    openType: 'tab',
    data: {
      table: {
        excludeDisplayColumns: ['expiresIn']
      },
      lease: {
        filterTypes: [LeaseFilterType.LEASE_STATUS, LeaseFilterType.OCCUPANCY_TYPE, LeaseFilterType.TERM_STATUS, LeaseFilterType.DATE_RANGE, LeaseFilterType.COMPACT_VIEW],
        endpointSuffix: 'lease-schedule',
        pageCode: 'lease-schedule',
      },
      pageHeader: {
        title: 'Look over your lease schedule',
        description: 'See your full lease schedule, including all statuses from planned to expired, in one place.'
      }
    },
    featureCodes: ['leasing_schedule_view_all']
  },
  // {
  //   label: 'Create a lease',
  //   componentToRegister: CreateALeaseDialogComponent,
  //   pageName: 'Create a lease',
  //   idPrefix: 'create-a-lease',
  //   sectionCode: 'leasing',
  //   pageCode: 'create-a-lease',
  //   openType: 'dialog',
  //   panelClass: 'dialog-large-responsive',
  //   data: {
  //     createMethod: LeaseCreateMethod.NEW_LEASE,
  //     lease: null,
  //     header: 'Create a new lease'
  //   },
  //   featureCodes: ['leasing_create_add_one']
  // },
  {
    label: 'Create a lease',
    componentToRegister: LeaseBookingsComponent,
    pageName: 'Create a lease',
    idPrefix: 'lease-bookings',
    sectionCode: 'leasing',
    pageCode: 'lease-bookings',
    openType: 'tab',
    data: {},
    featureCodes: ['leasing_create_add_one']
  }
]

export const accountsItems: PageSectionItemInfo[] = [
  {
    label: 'Tenant Transactions Summary',
    componentToRegister: DailyTransactionSummaryComponent,
    pageName: 'Tenant Transaction Summary',
    idPrefix: 'transactions',
    sectionCode: 'accounts',
    pageCode: 'tenant-transactions-summary',
    openType: 'tab',
    data: {},
    featureCodes: ['accounts_transactions_view_all', 'accounts_transactions_view_chart']
  },
  {
    label: 'Tenant Transaction History',
    componentToRegister: TransactionsScheduleComponent,
    pageName: 'Tenant Transaction History',
    idPrefix: 'transactions',
    sectionCode: 'accounts',
    pageCode: 'tenant-transaction-history',
    openType: 'tab',
    data: {},
    featureCodes: ['accounts_transactions_view_all', 'accounts_transactions_view_chart']
  },
  /*{
    label: 'Cash Trading Report',
    componentToRegister: TradingReportComponent,
    pageName: 'Cash Trading Report',
    idPrefix: 'cash-trading-report',
    sectionCode: 'accounts',
    pageCode: 'trading-report',
    openType: 'tab',
    data: {
      paymentMethod: 'CASH'
    },
    featureCodes: ['accounts_trading_report_view_all', 'accounts_trading_report_import']
  },*/
  {
    label: 'Shared POS Trading Report',
    componentToRegister: TradingReportComponent,
    pageName: 'Shared POS Trading Report',
    idPrefix: 'shared-pos-trading-report',
    sectionCode: 'accounts',
    pageCode: 'shared-pos-trading-report',
    openType: 'tab',
    data: {
      paymentMethod: 'ALL'
    },
    featureCodes: ['accounts_trading_report_view_all', 'accounts_trading_report_import']
  },
  {
    label: 'Run Tenant Pay-outs',
    componentToRegister: RunTenantPayoutsViewComponent,
    pageName: 'Run Tenant Pay-outs',
    idPrefix: 'run-tenant-payouts',
    sectionCode: 'accounts',
    pageCode: 'run-tenant-payouts',
    openType: 'tab',
    data: {},
    featureCodes: ['accounts_internal_admin']
  },
  {
    label: 'Run Client Pay-out',
    componentToRegister: RunClientPayoutsViewComponent,
    pageName: 'Run Client Pay-out',
    idPrefix: 'run-client-payouts',
    sectionCode: 'accounts',
    pageCode: 'run-client-payouts',
    openType: 'tab',
    data: {},
    featureCodes: ['accounts_internal_admin']
  },
  {
    label: 'Pay-out History',
    componentToRegister: PayoutHistoryListComponent,
    pageName: 'Pay-out History',
    idPrefix: 'payout-history',
    sectionCode: 'accounts',
    pageCode: 'payout-history',
    openType: 'tab',
    data: {},
    featureCodes: ['accounts_payouts_view_all', 'accounts_payout_history_view_all']
  },
  {
    label: 'Run Products',
    componentToRegister: RunProductsComponent,
    pageName: 'Run Products',
    idPrefix: 'run-products',
    sectionCode: 'accounts',
    pageCode: 'run-products',
    openType: 'tab',
    data: {},
    featureCodes: ['retailer_products_import_products', 'retailer_products_import_inventory']
  },
]

export const supportItem: PageSectionItemInfo = {
  label: 'Support',
  componentToRegister: CustomerSupportComponent,
  pageName: 'Support',
  idPrefix: 'support',
  sectionCode: 'support',
  pageCode: 'support',
  openType: 'tab',
  data: {},
  featureCodes: []
}

export const dashboardItems: PageSectionItemInfo[] = [
  {
    label: 'Leads Report',
    componentToRegister: DashboardsLeadsReportComponent,
    pageName: 'Leads Report',
    idPrefix: 'leads_report',
    sectionCode: 'dashboards',
    pageCode: 'leads_report',
    openType: 'tab',
    data: {},
    featureCodes: [
      'dashboards_leads_view_best_month',
      'dashboards_leads_view_qualified_leads',
      'dashboards_leads_view_approval_rates',
      'dashboards_leads_view_categories'
    ]
  },
  {
    label: 'Leasing Report',
    componentToRegister: DashboardsLeasingReportComponent,
    pageName: 'Leasing Report',
    idPrefix: 'leasing_report',
    sectionCode: 'dashboards',
    pageCode: 'leasing_report',
    openType: 'tab',
    data: {},
    featureCodes: [
      'dashboards_leasing_view_best_month',
      'dashboards_leasing_view_rental_income',
      'dashboards_leasing_view_rental_income_occupancy',
      'dashboards_leasing_view_trading_density_occupancy',
      'dashboards_leasing_view_rental_income_trading_density',
      'dashboards_leasing_view_effective_income_rent_ratio',
      'dashboards_leasing_view_rental_category_stats'
    ]
  },
  {
    label: 'Performance Report',
    componentToRegister: DashboardsPerformanceReportComponent,
    pageName: 'Performance Report',
    idPrefix: 'performance_report',
    sectionCode: 'dashboards',
    pageCode: 'performance_report',
    openType: 'tab',
    data: {},
    featureCodes: [
      'dashboards_sales_view_best_month',
      'dashboards_sales_view_overall_performance',
      'dashboards_sales_view_sales_comparison',
      'dashboards_sales_view_top_performers',
      'dashboards_sales_view_times_transactions',
      'dashboards_sales_view_category_performance',
      'dashboards_sales_view_footfall_statistics',
      'dashboards_sales_view_industry_performance_occupancy'
    ]
  },
  {
    label: 'Tenant Trading Report',
    componentToRegister: DashboardsRetailerReportComponent,
    pageName: 'Tenant Trading Report',
    idPrefix: 'tenant_trading_report',
    sectionCode: 'dashboards',
    pageCode: 'tenant_trading_report',
    openType: 'tab',
    data: {},
    featureCodes: [
      'dashboards_retailer_view_basket_size',
      'dashboards_retailer_view_best_month',
      'dashboards_retailer_view_best_sellers',
      'dashboards_retailer_view_busiest_times',
      'dashboards_retailer_view_daily_transaction',
      'dashboards_retailer_view_inventory_forecast',
      'dashboards_retailer_view_overall_performance',
      'dashboards_retailer_view_poor_sellers',
      'dashboards_retailer_view_rent_performance',
      'dashboards_retailer_view_retailers'
    ]
  },
  {
    label: 'Footfall Report',
    componentToRegister: DashboardFootfallComponentComponent,
    pageName: 'Footfall Report',
    idPrefix: 'footfall_report',
    sectionCode: 'dashboards',
    pageCode: 'footfall_report',
    openType: 'tab',
    data: {},
    featureCodes: ['dashboards_footfall_view_footfall_rosebank']//todo - change this to footfall
  },
  {
    label: 'On-Demand Rentals Report',
    componentToRegister: AtokuReportsComponent,
    pageName: 'On-Demand Rentals Report',
    idPrefix: 'atoku_reports',
    sectionCode: 'dashboards',
    pageCode: 'atoku_reports',
    openType: 'tab',
    data: {},
    featureCodes: ['atoku_reports_view']
  },
]

export const viewItems: PageSectionItemInfo[] = [
  {
    label: 'Lease View',
    componentToRegister: LeaseViewComponent,
    pageName: 'Lease :id',
    idPrefix: 'lease',
    sectionCode: 'leasing',
    pageCode: 'lease-schedule',
    openType: 'tab',
    data: {},
    featureCodes: ['leasing_planned_view_one', 'leasing_current_view_one', 'leasing_schedule_view_one']
  }
]

export const onDemandItems: PageSectionItemInfo[] = [
  {
    label: 'Calendar',
    componentToRegister: AtokuCalendarComponent,
    pageName: 'Calendar',
    idPrefix: 'atoku_calendar',
    sectionCode: 'on_demand',
    pageCode: 'atoku_calendar',
    openType: 'tab',
    data: {},
    featureCodes: ['atoku_calendar_view']
  },
  {
    label: 'Access Management',
    componentToRegister: AtokuUsersComponent,
    pageName: 'Access Management',
    idPrefix: 'atoku_users',
    sectionCode: 'on_demand',
    pageCode: 'atoku_users',
    openType: 'tab',
    data: {},
    featureCodes: ['atoku_users_view']
  },
  {
    label: 'Access Requests',
    componentToRegister: AtokuAccessRequestsComponent,
    pageName: 'Access Requests',
    idPrefix: 'atoku_access_requests',
    sectionCode: 'on_demand',
    pageCode: 'atoku_access_requests',
    openType: 'tab',
    data: {},
    featureCodes: ['atoku_access_requests_view']
  },
  {
    label: 'Access Entries',
    componentToRegister: AtokuAccessEntriesComponent,
    pageName: 'Access Entries',
    idPrefix: 'atoku_access_entries',
    sectionCode: 'on_demand',
    pageCode: 'atoku_access_entries',
    openType: 'tab',
    data: {},
    featureCodes: ['atoku_access_entries_view']
  },
]
